










import { Component, Prop, Vue } from "vue-property-decorator";
import AppPrompt from "@/components/AppPrompt.vue";
import request from "@/api/newchongqing";
@Component({
  components: { AppPrompt }
})
export default class GraphicPage extends Vue {
  @Prop()
  appId!: string | number;
  @Prop()
  infoClassifyId!: string;
  time = 5;
  timer: any;
  showBtn: any;
  isInApp: Boolean = false;
  mounted() {
    this.showBtn = true;
    this.isInApp = ZWY_CLOUD.isOpenInApp();
    this.isInApp ? (this.time = 5) : (this.time = 1);

    if (ZWY_CLOUD.isOpenInApp() || this.appId == "1") {
      this.countDown();
    } else {
      let btn = document.getElementById("returnBtn") as HTMLDivElement;
      btn && btn.setAttribute("class", "none");
    }
    if (ZWY_CLOUD.isOpenInApp()) {
      ZWY_CLOUD.bottomBarConfig({
        isShowBottom: 0,
        callBack_replyList: "releaseReplyList",
        praiseNum: 0,
        isPraised: 0
      });
      ZWY_CLOUD.topBarConfig({
        isShowTop: 1,
        isShowBackBtn: 1,
        isShowTitle: "",
        isShowMoreBtn: "0"
      });
    } else {
      document.title = "该条信息不存在";
    }
  }
  // 倒计时
  countDown() {
    if (this.time > 0) {
      this.timer = setTimeout(() => {
        this.time -= 1;
        this.countDown();
      }, 1000);
    } else {
      this.stopCountDown();
    }
  }
  // 停止倒计时
  stopCountDown() {
    clearTimeout(this.timer);
    this.goback();
  }
  goback() {
    if (ZWY_CLOUD.isOpenInApp()) {
      ZWY_CLOUD.appCloseWeb({ type: 0 });
    } else if (this.appId == "1") {
      request
        .getNotFoundUrl({
          sourceId: this.infoClassifyId,
          sourceType: "1"
        })
        .then(res => {
          if (res.code >= 0) {
            if (/http/.test(res.data)) {
              window.location.href = res.data;
            } else {
              window.location.href = "http://" + res.data;
            }
          } else {
            window.location.href = "http://m.cqnews.net/";
          }
        })
        .catch(e => {
          window.location.href = "http://m.cqnews.net/";
        });
    }
  }
}
